
import {IContactFormData} from '../hydromet/help/help.controller';

export interface IContactEmailApi {
  sendContactEmail(contactFormData: IContactFormData): ng.IPromise<void>;
}

export default class ContactEmailApi implements IContactEmailApi {
  static $inject = ['backendUrl', '$http'];

  private endpoint: string;

  constructor(backendUrl: string, private $http: ng.IHttpService) {
    this.endpoint = `${backendUrl}/email`;
  }

    sendContactEmail(contactFormData: IContactFormData): ng.IPromise<void> {

    return this.$http({
      url: this.endpoint,
      method: 'POST',
      data: contactFormData
    }).then(httpData => {
    });

  }

}



/** WEBPACK FOOTER **
 ** ./app/api/contact-email-api.service.ts
 **/